module.exports = __webpack_public_path__ + "img/planet-flat.a112ec02.svg";